export const capa = {
  url: import.meta.env.VITE_CORRECTIVE_ACTION_PLAN_SERVICE_URI,
};

export const users = {
  url: import.meta.env.VITE_USERS_SERVICE_URI,
};

export const authentication = {
  url: import.meta.env.VITE_AUTHENTICATION_SERVICE_URI,
};

export const riskAnalysis = {
  url: import.meta.env.VITE_RISK_ANALYSIS_SERVICE_URI,
};

export const companies = {
  url: import.meta.env.VITE_COMPANIES_SERVICE_URI,
};

export const constants = {
  url: import.meta.env.VITE_CONSTANTS_SERVICE_URI,
};

export const supplierquestionnaire = {
  url: import.meta.env.VITE_SUPPLIER_QUESTIONNAIRE_SERVICE_URI,
};

export const audits = {
  url: import.meta.env.VITE_AUDITS_SERVICE_URI,
};

export const cascadeMap = {
  url: import.meta.env.VITE_CASCADE_MAP_SERVICE_URI,
};

export const analytics = {
  url: import.meta.env.VITE_DASHBOARD_ANALYTICS_SERVICE_URI,
};

export const backend = {
  url: import.meta.env.VITE_BACKEND_URI,
};
